﻿import { arrayOf, bool, exact, oneOfType, shape, string } from "prop-types";

/** @deprecated use TypeScript interface or type instead */
export const projectTemplateMilestoneType = shape({
  id: string,
  name: string,
  abbreviation: string,
  distributionsRequired: bool,
  documentsRequired: bool,
  targetDatesRequired: bool,
  areProjectSkusRequired: bool,
  defaultFor: arrayOf(string),
  canBeAdded: arrayOf(string),
  canBeDeleted: arrayOf(string),
  canBeSkipped: arrayOf(string),
  approvalRequired: oneOfType([
    arrayOf(
      exact({
        id: string,
        roleId: string,
        canSetNotApplicable: bool,
        defaultForProductCategories: arrayOf(string),
        region: string,
        functionalArea: string,
      })
    ),
    arrayOf(string),
  ]),
  createdAt: string,
  createdBy: string,
  approvers: arrayOf(
    exact({
      canSetNotApplicable: bool,
      defaultForProductCategories: arrayOf(string),
      functionalArea: string,
      id: string,
      region: string,
      roleId: string,
    })
  ),
  notification: exact({
    roles: arrayOf(
      exact({
        canSetNotApplicable: bool,
        defaultForProductCategories: arrayOf(string),
        functionalArea: string,
        id: string,
        region: string,
        roleId: string,
      })
    ),
    groups: arrayOf(
      exact({
        defaultForProductCategories: arrayOf(string),
        groupId: string,
        id: string,
        required: bool,
      })
    ),
    coreTeamGroups: arrayOf(
      exact({
        required: bool,
        defaultForProductCategories: arrayOf(string),
      })
    ),
  }),
  isActive: bool,
  shouldCompleteProject: bool,
  secureProjectOnCompletion: bool,
  projectLeaderApprovers: arrayOf(
    exact({
      canSetNotApplicable: bool,
      id: string,
      isNotApplicable: bool,
      productCategories: arrayOf(string),
      regionId: string,
    })
  ),
});
